<div class="row">
    <div class="col-xs-12">
        <ui-figure-caption>
            <ui-figure-text>
                <h4>Andel ungskog på mellanmark som är föryngrad med tall</h4>
            </ui-figure-text>
            <ui-figure-sub-text> Andel mellanmark: {{ andelMellanMarker }}% för de tre senaste inventeringarna </ui-figure-sub-text>
        </ui-figure-caption>

        <app-google-combochart [data]="data" [options]="options" [chartName]="chartName"></app-google-combochart>
        <ui-error-margin />
    </div>
</div>
